'use strict';

/**
 *
 * @name: nownessApp.persistentVideo
 *
 */

import NnPersistentVideoDirective from './nn-persistent-video.directive';

const PersistentVideoModule = angular
  .module('nownessApp.persistentVideo', [])
  .directive('nnPersistentVideo', NnPersistentVideoDirective);

export default PersistentVideoModule.name;



// WEBPACK FOOTER //
// ./app/components/nn-persistent-video/nn-persistent-video.module.js